import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import { useWindowSize } from '@react-hook/window-size';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import {
  viewerPhotoDocumentDeleteInit,
  viewerPhotoDocumentDelete,
} from '../../actions/Viewer/ViewerActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Textbox,
  Text,
} from './PhotoDocumentDelete.style';
// import { Breakpoints } from '../../assets/Variables.style';

const PhotoDocumentDeleteInner = ({
  id,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const dispatch = useDispatch();
  const firebaseStore = useSelector((state) => state.firebase);
  const { profile } = firebaseStore;
  const isProfileCompany = profile.company && profile.company.id ? true : false;

  const viewerPhotoDocumentDeleteStore = useSelector(
    (state) => state.viewerPhotoDocumentDeleteStore
  );
  const {
    isLoading,
    isSuccess,
    isError,
    error,
  } = viewerPhotoDocumentDeleteStore;

  const onSubmit = (e) => {
    e.preventDefault();
    if (isProfileCompany) {
      dispatch(viewerPhotoDocumentDelete({ id }));
    }
  };

  useEffect(() => {
    dispatch(viewerPhotoDocumentDeleteInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleProcess(isLoading ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, isError]);

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.photoDocumentDelete.wrapper}>
        <Header theme={theme.photoDocumentDelete.header}>
          <Title theme={theme.photoDocumentDelete.title}>
            {intl.formatMessage({
              id: 'DELETE_PHOTO_DOCUMENT.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.photoDocumentDelete.text.default}>
                {intl.formatMessage({
                  id: `DELETE_PHOTO_DOCUMENT.TEXT.THE_PHOTO_DOCUMENT_HAS_BEEN_SUCCESSFULLY_DELETED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => {
              handleClose();
            }}
          >
            {intl.formatMessage({ id: 'DELETE_PHOTO_DOCUMENT.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  return (
    <>
      {isSuccess ? (
        renderSuccessPanel()
      ) : (
        <Form onSubmit={onSubmit}>
          <Wrapper theme={theme.photoDocumentDelete.wrapper}>
            <Header theme={theme.photoDocumentDelete.header}>
              <Title theme={theme.photoDocumentDelete.title}>
                {intl.formatMessage({
                  id: 'DELETE_PHOTO_DOCUMENT.DELETE_PHOTO_DOCUMENT',
                })}
              </Title>
            </Header>
            <Content>
              <Box>
                <Textbox center>
                  <Text theme={theme.photoDocumentDelete.text.default}>
                    {intl.formatMessage({
                      id: `DELETE_PHOTO_DOCUMENT.TEXT.ARE_YOU_SURE_WANT_TO_DELETE_PHOTO_DOCUMENT`,
                    })}
                    <br />
                    {intl.formatMessage({
                      id: `DELETE_PHOTO_DOCUMENT.TEXT.THIS_OPERATION_CANNOT_BE_UNDONE`,
                    })}
                  </Text>
                </Textbox>
              </Box>
            </Content>
            {isError ? (
              <Textbox>
                <Text theme={theme.photoDocumentDelete.text.error}>
                  {intl.formatMessage({
                    id: `DELETE_PHOTO_DOCUMENT.TEXT.ERROR.${error}`,
                    defaultMessage: error,
                  })}
                </Text>
              </Textbox>
            ) : (
              ''
            )}
            <Footer>
              <Button
                type='button'
                theme={theme.button.alt}
                disabled={isLoading}
                onClick={() => {
                  handleClose();
                }}
              >
                {intl.formatMessage({ id: 'DELETE_PHOTO_DOCUMENT.CANCEL' })}
              </Button>
              <Button theme={theme.button.default} disabled={isLoading}>
                {isLoading
                  ? intl.formatMessage({
                      id: 'DELETE_PHOTO_DOCUMENT.PLEASE_WAIT',
                    })
                  : intl.formatMessage({
                      id: `DELETE_PHOTO_DOCUMENT.DELETE`,
                    })}
              </Button>
            </Footer>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const PhotoDocumentDelete = ({
  id,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  // const [width] = useWindowSize();
  return (
    <Modal
      handleClose={handleClose}
      // fullscreen={width <= Breakpoints.md ? true : false}
    >
      <PhotoDocumentDeleteInner
        id={id}
        handleClose={handleClose}
        handleProcess={handleProcess}
      />
    </Modal>
  );
};

PhotoDocumentDeleteInner.propTypes = {
  id: PropTypes.string,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

PhotoDocumentDelete.propTypes = {
  id: PropTypes.string,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

export default PhotoDocumentDelete;
